import(/* webpackMode: "eager" */ "/codebuild/output/src1783294825/src/patient-app/src/components/loader/Loader.tsx");
